import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import {
  findAllDiscount,
  findAllActiveDiscount,
  insertDiscount,
  updateDiscount,
  deleteDiscount,
  findByIDDiscount,
  activeInactiveDiscount,
} from "./discount.service";
import { IDiscount, IDiscountState } from "./discountModel";

const initialState: IDiscountState = {
  loading: false,
  formLoading: false,
  error: "",
  DiscountList: [],
  ActiveDiscountList: [],
  DiscountID: null,
  isDrawerOpen: false,
  DiscountDetail: {
    FromValue: null,
    ToValue: null,
    DiscountPercent: null,
    IsActive: true,
  },
  isDeleteModalOpen: false,
  DeleteDiscountID: null,
};

const discountSlice = createSlice({
  name: "discount",
  initialState,
  reducers: {
    setDiscountID: (state, action: PayloadAction<number | null>) => {
      state.DiscountID = action.payload;
    },
    clearDiscountID: (state) => {
      state.DiscountID = null;
    },
    clearDiscountDetails: (state) => {
      state.DiscountDetail = initialState.DiscountDetail;
      state.DiscountID = null;
    },
    openDrawer: (state) => {
      state.isDrawerOpen = true;
    },
    closeDrawer: (state) => {
      state.isDrawerOpen = false;
      state.DiscountID = null;
      state.DiscountDetail = initialState.DiscountDetail;
    },
    openDeleteModal: (state, action: PayloadAction<number>) => {
      state.DeleteDiscountID = action.payload;
      state.isDeleteModalOpen = true;
    },
    closeDeleteModal: (state) => {
      state.isDeleteModalOpen = false;
      state.DeleteDiscountID = null;
    },
  },
  extraReducers: (builder) => {
    // Find All Active
    builder.addCase(findAllActiveDiscount.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(
      findAllActiveDiscount.fulfilled,
      (state, action: PayloadAction<IDiscount[]>) => {
        state.loading = false;
        state.ActiveDiscountList = action.payload || [];
        state.error = "";
      },
    );
    builder.addCase(findAllActiveDiscount.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
      state.ActiveDiscountList = [];
    });

    // Find All
    builder.addCase(findAllDiscount.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(
      findAllDiscount.fulfilled,
      (state, action: PayloadAction<IDiscount[]>) => {
        state.loading = false;
        state.DiscountList = action.payload || [];
        state.error = "";
      },
    );
    builder.addCase(findAllDiscount.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
      state.DiscountList = [];
    });

    // Insert
    builder.addCase(insertDiscount.pending, (state) => {
      state.formLoading = true;
      state.error = "";
    });
    builder.addCase(insertDiscount.fulfilled, (state) => {
      state.formLoading = false;
    });
    builder.addCase(insertDiscount.rejected, (state, action) => {
      state.formLoading = false;
      state.error = action.error.message || "Something went wrong";
    });

    // Update
    builder.addCase(updateDiscount.pending, (state) => {
      state.formLoading = true;
      state.error = "";
    });
    builder.addCase(updateDiscount.fulfilled, (state) => {
      state.formLoading = false;
    });
    builder.addCase(updateDiscount.rejected, (state, action) => {
      state.formLoading = false;
      state.error = action.error.message || "Something went wrong";
    });

    // Find By ID
    builder.addCase(findByIDDiscount.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(findByIDDiscount.fulfilled, (state, action: any) => {
      state.loading = false;
      state.DiscountDetail = action.payload;
    });
    builder.addCase(findByIDDiscount.rejected, (state, action) => {
      state.loading = false;
      state.DiscountDetail = initialState.DiscountDetail;
      state.error = action.error.message || "Something went wrong";
    });

    // Delete
    builder.addCase(deleteDiscount.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(deleteDiscount.fulfilled, (state) => {
      state.loading = false;
    });
    builder.addCase(deleteDiscount.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
    });

    // Active/Inactive
    builder.addCase(activeInactiveDiscount.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(activeInactiveDiscount.fulfilled, (state) => {
      state.loading = false;
    });
    builder.addCase(activeInactiveDiscount.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
    });
  },
});

export const {
  setDiscountID,
  clearDiscountID,
  clearDiscountDetails,
  openDrawer,
  closeDrawer,
  openDeleteModal,
  closeDeleteModal,
} = discountSlice.actions;
export default discountSlice.reducer;
